const ru = {
  layout: {
    cos_button: {
      phone: 'Телефон',
      update_phone_number_message: 'Номер телефона успешно обновлен!'
    },
    time: {
      days: 'Дн',
      hours: 'Ч',
      mins: 'Мин',
      secs: 'Сек',
      starts: 'Начинается',
      starts_immediately: 'Начинается сразу же'
    },
    field: {
      host: 'Организатор'
    },
    copy: 'Копировать'
  },
  validations: {
    email: 'нужен действительный email',
    phone: 'имеет неверное значение',
    required_field: 'обязательное поле'
  },
  mailer: {
    need_help: 'Нужна помощь?',
    stop_reminders: 'Отказаться от уведомлений',
    cancel_registration: 'Отменить регистрацию',
    report_abuse: 'Пожаловаться на нарушение'
  },
  datetime: {
    no_sessions: 'Нет доступных сессий',
    empty_label: 'Дата/время'
  },
  errors: {
    verification_failed: 'Проверка не пройдена. Пожалуйста, попробуйте ещё раз.',
    session_unavailable: 'Выбранное вами время больше недоступно. Пожалуйста, выберите другое время сессии.',
    challenge_email_mismatch:
      'Пожалуйста, зарегистрируйтесь с тем же адресом электронной почты, который вы использовали при регистрации на событие.'
  }
}

export default ru
